import { LOCATION_TYPE_TITLE } from '../../types/models/Location.model'
export const UNITED_STATES = 'United States'
export const USA = 'USA'
export const UNITED_KINGDOM = 'United Kingdom'
export const CANADA = 'Canada'
export const NORTH_AMERICA = 'North America'
export const UNITED_STATES_NAMES = new Set([UNITED_STATES, USA])
export const US_CANADA_COUNTRY_GROUP = new Set([UNITED_STATES, USA, CANADA])
export const US_UK_CANADA_COUNTRY_GROUP = new Set([
  UNITED_STATES,
  USA,
  UNITED_KINGDOM,
  CANADA
])

export const LOCATION_TYPE: Record<string, LOCATION_TYPE_TITLE> = {
  CITY: 'City',
  REGION: 'Region',
  COUNTRY: 'Country',
  CONTINENT: 'Continent',
  COLLOQUIAL_AREA: 'ColloquialArea'
}

export const DISALLOWED_LOCATION_TYPES = [LOCATION_TYPE.COLLOQUIAL_AREA]

export const CONTINENT_LOCATIONS = {
  ASIA: 'Asia',
  AFRICA: 'Africa',
  EUROPE: 'Europe',
  NORTH_AMERICA: 'North America',
  SOUTH_AMERICA: 'South America',
  AUSTRALIA: 'Australia',
  OCEANIA: 'Oceania',
  ANTARTICA: 'Antarctica'
}

export const CONTINENT_LOCATION_LIST = [
  'Asia',
  'Africa',
  'Europe',
  'North America',
  'South America',
  'Australia',
  'Oceania',
  'Antarctica'
]

export const US_STATES = {
  ALABAMA: 'Alabama',
  ALASKA: 'Alaska',
  ARIZONA: 'Arizona',
  ARKANSAS: 'Arkansas',
  CALIFORNIA: 'California',
  COLORADO: 'Colorado',
  CONNECTICUT: 'Connecticut',
  DELAWARE: 'Delaware',
  FLORIDA: 'Florida',
  GEORGIA: 'Georgia',
  HAWAII: 'Hawaii',
  IDAHO: 'Idaho',
  ILLINOIS: 'Illinois',
  INDIANA: 'Indiana',
  IOWA: 'Iowa',
  KANSAS: 'Kansas',
  KENTUCKY: 'Kentucky',
  LOUISIANA: 'Louisiana',
  MAINE: 'Maine',
  MARYLAND: 'Maryland',
  MASSACHUSETTS: 'Massachusetts',
  MICHIGAN: 'Michigan',
  MINNESOTA: 'Minnesota',
  MISSISSIPPI: 'Mississippi',
  MISSOURI: 'Missouri',
  MONTANA: 'Montana',
  NEBRASKA: 'Nebraska',
  NEVADA: 'Nevada',
  NEW_HAMPSHIRE: 'New Hampshire',
  NEW_JERSEY: 'New Jersey',
  NEW_MEXICO: 'New Mexico',
  NEW_YORK: 'New York',
  NORTH_CAROLINA: 'North Carolina',
  NORTH_DAKOTA: 'North Dakota',
  OHIO: 'Ohio',
  OKLAHOMA: 'Oklahoma',
  OREGON: 'Oregon',
  PENNSYLVANIA: 'Pennsylvania',
  RHODE_ISLAND: 'Rhode Island',
  SOUTH_CAROLINA: 'South Carolina',
  SOUTH_DAKOTA: 'South Dakota',
  TENNESSEE: 'Tennessee',
  TEXAS: 'Texas',
  UTAH: 'Utah',
  VERMONT: 'Vermont',
  VIRGINIA: 'Virginia',
  WASHINGTON: 'Washington',
  WEST_VIRGINIA: 'West Virginia',
  WISCONSIN: 'Wisconsin',
  WYOMING: 'Wyoming'
}
export const US_STATES_LIST = Object.values(US_STATES)

export const US_STATES_EXCLUDED_FROM_MENU = [
  US_STATES.MONTANA,
  US_STATES.SOUTH_DAKOTA,
  US_STATES.NORTH_DAKOTA,
  US_STATES.WYOMING,
  US_STATES.VERMONT,
  US_STATES.ALASKA,
  US_STATES.DELAWARE,
  US_STATES.RHODE_ISLAND,
  US_STATES.WEST_VIRGINIA,
  US_STATES.IDAHO
]

export const BANNED_LOCATION_TITLES = new Set([NORTH_AMERICA])
export const BANNED_BREADCRUMBS_LOCATION_TITLES_ON_FACETS = new Set([
  NORTH_AMERICA,
  UNITED_STATES
])
